<script lang="ts" setup>
import { useToastStore } from "@/stores/toast";
import { ToastType } from "@/models/app";
import Icon from "@/components/Icon.vue";

const toastStore = useToastStore();
const icons = {
  [ToastType.Success]: 'done',
  [ToastType.Error]: 'error',
  [ToastType.Info]: 'info',
  [ToastType.Warning]: 'warning',
};
const colors = {
  [ToastType.Success]: 'success',
  [ToastType.Error]: 'error',
  [ToastType.Info]: 'info',
  [ToastType.Warning]: 'warning',
};
</script>

<template id="toast">
  <v-snackbar
    v-for="([id, toast], index) in toastStore.messages.entries()"
    :key="toast.id"
    :model-value="true"
    :timeout="toast.timeout"
    :style="{ bottom: `${index * 60 + 20}px` }"
    :color="colors[toast.type]"
  >
    <Icon :icon="icons[toast.type]" :size="22" class="mr-2" />

    {{ toast.message }}
    <template v-slot:actions>
      <v-btn icon="close" color="white" @click="toastStore.remove(toast.id)" />
    </template>
  </v-snackbar>
</template>

<style lang="scss" scoped>
#toast {

}
</style>
